export default {
  icon: ' mdi-cart',
  text: 'Vendas',
  permissions: [
    { name: 'saleViewDashboardIndex', text: 'Dashboard de vendas', value: 0 },
    { name: 'salesIndex', text: 'Visualizar Vendas', value: 0 },
    { name: 'salesCreateEdit', text: 'Criar/Editar Vendas', value: 0 },
    { name: 'salesCancel', text: 'Cancelar Vendas', value: 0 },
    { name: 'salesOtherUser', text: 'Vender em nome de outro usuário', value: 0 },
    { name: 'userAproveSale', text: 'Aprovar vendas', value: 0 },
    { name: 'userAproveSaleWithNegativeStock', text: 'Aprovar vendas de produtos com estoque negativo', value: 0 },
  ]

}